export default __webpack_public_path__ + "static/media/template_pro__0015_12---ChristovVol.2d376562.png";